import { render, staticRenderFns } from "./management-role-view.vue?vue&type=template&id=e6a82c20&"
import script from "./management-role-view.vue?vue&type=script&lang=js&"
export * from "./management-role-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports